<div class="flex flex-col gap-3 p-3">
  <div
    class="flex flex-wrap items-center justify-between gap-2 whitespace-nowrap"
  >
    <ag1-title label="500 Error" />
  </div>
  <div
    class="grid h-[calc(100vh-13rem)] place-items-center gap-2 overflow-y-auto @container"
  >
    <ng-container *ngTemplateOutlet="serverErrorDisplay" />
  </div>
</div>

<ng-template #serverErrorDisplay>
  <div>
    <div
      class="grid h-full max-w-4xl grid-cols-1 items-center justify-items-center gap-10 overflow-visible p-5 @lg:grid-cols-2"
    >
      <!-- left -->
      <div
        class="row-start-2 flex max-w-lg flex-col items-center text-center @lg:row-start-1 @lg:items-start @lg:text-start"
      >
        <h1 class="text-5xl font-extrabold text-steel-blue-600">
          Page Not Found
        </h1>
        <p class="mt-5 text-xl text-gray-600">
          Looks like an error has occurred. This error has been logged in our
          system. Feel free to contact us if you feel something is incorrect.
        </p>
        <p class="mt-5 font-semibold">Error code: 500</p>
        <div class="mt-5 flex items-center gap-3">
          <p-button (click)="goBack()" label="Go Back" />
        </div>
      </div>

      <!-- right -->
      <div class="relative row-start-1 h-fit max-h-fit w-fit p-1">
        <p
          class="absolute left-3 top-3 z-10 scale-150 text-9xl text-yellow-500/40"
        >
          5
        </p>
        <img
          src="/assets/images/error_images/lemon-500-page.png"
          alt="500 Image"
          class="relative z-20"
        />
        <p
          class="absolute bottom-0 right-0 z-10 scale-150 text-9xl text-yellow-500/40"
        >
          0
        </p>
      </div>
    </div>
  </div>
</ng-template>
